import * as Yup from 'yup';

export default Yup.object({
  name: Yup.string()
    .min(1, 'Must be 1 character or more')
    .max(255, 'Must be 255 characters or less'),
  sections: Yup.array().of(
    Yup.object().shape({
      heading: Yup.string().required('Please enter a heading'),
      questions: Yup.array().of(
        Yup.object().shape({
          text: Yup.string().required('Required'),
        }),
      ),
    }),
  ),
});
